import PasswordResetPromptContainer from './PasswordResetPromptContainer';

export default PasswordResetPromptContainer;
